import { render, staticRenderFns } from "./user-presentation.vue?vue&type=template&id=1836de0b&scoped=true&"
import script from "./user-presentation.vue?vue&type=script&lang=js&"
export * from "./user-presentation.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1836de0b",
  null
  
)

export default component.exports